import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setSkippedOnboarding } from '../session/actions'

/**
 * Hook to encapsulate the functionality to skip onboarding
 * and navigate to the dashboard
 *
 * @returns A function to call when the user wants to skip onboarding
 */
export const useSkipOnboarding = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  /**
   * Marks onboarding as skipped in Redux and navigates to the dashboard
   */
  const skipOnboarding = () => {
    // Set skippedOnboarding flag to true in Redux
    dispatch(setSkippedOnboarding(true))

    // Navigate to dashboard
    navigate('/app/dashboard', { replace: true })
  }

  return skipOnboarding
}
